module.exports = __webpack_public_path__ + "static/media/ke.0bbfd051.svg";